import { Component, inject, OnInit, effect } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common'; 
import * as bootstrap from 'bootstrap';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';

import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { KnownSteps } from '../../../shared/models/session.model';
import { DirectApiService, updateSales2, payment, AddContactInformationParams, UpdateQuote } from '../../../shared/directApi.service';
import { MatDialog, } from '@angular/material/dialog';

import { LayoutChangeService } from '../../../shared/layout-change.service';
import { environment } from '../../../../environments/environment';
import { ItemsService } from '../../../shared/items.service';
import { PromoService } from '../../../shared/promo.service';


@Component({
  selector: 'app-form-navigation-controls',
  template: `
  <!-- <span>Form Navigation Controls</span> -->
    <div class="d-flex col justify-content-between" >

    <!-- <div>Yeah this is loading</div> -->

      <div class=" row-3 " >
        @if(this.thisStepRef.index > 0){
          <button type="button" class="btn backward-button " 
            (click)="previousStep()" clickable
          >
            <img src="assets/Icons/arrow-sm-left-dark.svg" alt="Back">
            <span class="text-disabled-blue">Back</span>
          </button>
        }
      </div>

      @if( this.thisStepRef.index == 0){
        <div class="row-4"></div>
      }

      <div class=" row-3 ">
        @if(this.thisStepRef.index < this.maxSteps - 1){
          <button type="button"
            [ngClass]=" this.thisStepRef.completed? 'forward-button-enabled' : 'forward-button-disabled'"
            class="btn  float-end"
            (click)="nextStep()" clickable
          >
            <span [ngClass]=" this.thisStepRef.completed? 'text-enabled' : 'text-disabled' ">Next</span>

            @if(this.thisStepRef.completed){
              <img src="assets/Icons/arrow-sm-right.svg" alt="Next">
            }
            @if(!this.thisStepRef.completed){
              <img src="assets/Icons/arrow-sm-right-gray.svg" alt="Next">
            }

          </button>  
        }

        @if(this.thisStepRef.index == this.maxSteps - 1){
          <button type="button"
            [ngClass]=" this.thisStepRef.completed? 'forward-button-enabled' : 'forward-button-disabled'"
            class="btn  float-end"
            (click)="nextStep()" clickable
          >
            Checkout
          </button>
        }

        @if(this.thisStepRef.index == this.maxSteps){
          <button type="button"
            [disabled]="submitting"
            [ngClass]=" this.thisStepRef.completed === true ? 'forward-button-enabled' : 'forward-button-disabled'"
            class="btn  float-end"
            (click)="submitPayment()" clickable
          >
            Submit Payment
          </button>
        }

      </div>
    </div>

  `,
  standalone: true,
  styleUrls: [
    './form-navigation-controls.component.scss'
  ],
  host: {'class': 'form-navigation-controls'},
  imports: [
    NgClass, 
    MatButtonModule,
  ]
})

export class FormNavigationControlsComponent implements OnInit{

  stepIsComplete: boolean = false;
  submitting:boolean = false;

  readonly dialog = inject(MatDialog);


  thisStepRef = {} as KnownSteps;
  isMobile: boolean = false;
  paymentTestingLock: boolean = false;
  SalePromoCode: string = '';


  constructor(
    public directSessionLogic: DirectSessionLogicService,
    public directApiService: DirectApiService,
    private layoutChangeService: LayoutChangeService,
    public router: Router,
    public itemService: ItemsService,
    public responsive: BreakpointObserver,
    public promoService: PromoService
  ) {

    let stuff = this.directSessionLogic.knownStepsListSignalValue;

    effect(() => {
      const step = this.currentStep;
      this.updateCurrentStepRef(step);
    });

  }

  get knownSteps(): KnownSteps[] {
    return this.directSessionLogic.knownStepsListSignal();
  }
  get maxSteps(): number {
    return this.knownSteps.length -1;
  }
  get currentStep():number{
    let stepFromSignal = this.directSessionLogic.currentStepSignal();
    return stepFromSignal;
  }

  ngOnInit(){
    this.responsive.observe([
      Breakpoints.Small,Breakpoints.XSmall
      ])
      .subscribe(result => {
        this.isMobile = false; 
        if (result.matches) 
          this.isMobile = true;      
    });

    this.paymentTestingLock = environment.ConnectionInfo.paymentTesting === "true";
    this.SalePromoCode = environment.CompanyInfo.FortePromoCode;
  }




  updateCurrentStepRef(step: number){
    // Ensure this.step is within bounds of knownSteps array
    if (this.knownSteps.length > step && step >= 0) {
      this.thisStepRef = this.knownSteps[step];
    } 
  }


  async previousStep() {
    let changeStep = this.currentStep - 1;
    if(await this.directSessionLogic.changingStepSignal(changeStep)){
      const navUrl = this.knownSteps[changeStep].reference;

      this.directSessionLogic.unCompleteStepAfter(changeStep);
      this.directSessionLogic.redirectToStepSignal(navUrl)
    }
  }

  async nextStep() {
    let changeStep = this.currentStep + 1;

    if( this.isContactInfoStep() ){
      this.changingLeadInformation();
    }   

    let sessionIDvalue = parseInt( this.directSessionLogic.trimmedSessionSignalValue.sessionId ) ?? 0;
    if(sessionIDvalue > 0){ 
      this.updateQuoteFromSession('5'); //use 5 for pitched
    }

    if(await this.directSessionLogic.changingStepSignal(changeStep)){
      const navUrl = this.knownSteps[changeStep].reference;
      this.directSessionLogic.redirectToStepSignal(navUrl);
    }
  }

  async submitPayment() { 
    
    console.log('submitting payment');

    //get all data from customer
    let session = this.directSessionLogic.trimmedSessionSignal();
    let customer = this.directSessionLogic.customerSignal();
    let plan = this.directSessionLogic.selectedPlanSignalValue;
    let customerId = session.customerId;
    let coupon = this.promoService.couponSignal();
    let totalCost = session.totalCost;

    let planFriendlyName = plan.name;


    //parse data for api
    let sale: updateSales2 = {} as updateSales2;
    let payment: payment = {} as payment;

    console.log("selected plan: ", plan);
    if(plan.defaultIncluded?.length > 0) {
      console.log("Found default items");
       
      if(plan.defaultIncluded){
        for(const item of plan.defaultIncluded){
          if(item === 'children') {
            console.log("child surcharge from built in items");
            sale.gensur1 = "IDC";
          }
        }
      }
    }

    let cartItems = this.directSessionLogic.cartItemsSignalValue;
    if(cartItems?.length > 0) {
      for(const sel of cartItems) {
        if(sel.optionValue === 'IDC') {
          //child surcharge
          sale.gensur1 = sel.optionValue;
          break;
        }
      }
    }

    sale.cuscost = "0";
    sale.lastName = customer.lastName;
    sale.firstName = customer.firstName;
    sale.address = customer.address;
    sale.city = customer.city;
    sale.state = customer.state;
    sale.zip = customer.zip;
    sale.phone = customer.phoneNumber;
    sale.email = customer.email;
    sale.coverage = plan.forteCode;
    sale.appNumber = customerId?? 'x';
    sale.promo = coupon?.forteCode ?? this.SalePromoCode ;   // will be related to the coupon code but will default to the company promo code
    sale.listCode = plan.forteCode;                         // sales code for the plan
    sale.listCode2 = '';
    sale.cuscost = totalCost.toString();
    sale.downpay = '0';
    payment.amount = totalCost;
    payment.description = '';
    payment.cardHolder = customer.cardHolderName;                     
    payment.cardNumber = customer.cardEncrypted;
    payment.cardExp = customer.dateEncrypted;
    payment.invoice = '';
    sale.deduct = '0';
    sale.term = 'MONTHLY';

    //Send to API
    if( this.paymentTestingLock && customer.ccLast4 === "1111" ){
      console.log("+testing caught sale: ", sale);
      console.log("+testing caught pmnt: ", payment);
      console.log("+testing caught PFN: ", planFriendlyName);
      session.purchaseRef = "fake response number for 4111 testing";
      this.directSessionLogic.setSessionIp();
      this.router.navigate(['/purchaseConfirmed']);

    }else{

      this.submitting = true;
      this.directApiService.setPayment( payment, sale, planFriendlyName ).subscribe({
        next: (res) => {
          if(res && res.responseCode) {
            let isSuccess:boolean = res.responseCode === '0000';
            if(isSuccess) {
              //set forte id
              session.purchaseRef = res.response.resultRefNum;
              this.directSessionLogic.setSessionIp();
              this.submitting = false;
              this.router.navigate(['/purchaseConfirmed']);

              this.directApiService.setLoading(""); //spinner off
            }
            else {
              //res.responseCode is not 0000
              this.paymentSubmissionError(res);
            }
          } else{
            //res.responseCode doesn't exist
            this.paymentSubmissionError(res);
          }
          this.submitting = false;
        },
        error: (err) => {

          this.paymentSubmissionError(err);
        }
      });

    }
  }

  paymentSubmissionError(note: string){
    setTimeout(() => {
      this.directApiService.setLoading(""); //spinner off

      this.submitting = false;
      console.error('payment error: ', note);
      this.bootstrapDialog();
    },200);
  }

  isContactInfoStep() {
    return this.directSessionLogic.getCurrentStepSignal().reference === 'contact';
  }

  bootstrapDialog(){
    
    const myModalBootstrap = new bootstrap.Modal("#bs-error-component",{
      keyboard: false,
      backdrop: true,
      focus: true
    });
    myModalBootstrap.show();
  }

  changingLeadInformation(){
    let session = this.directSessionLogic.trimmedSessionSignal();

    if(session.customerId === undefined || session.customerId === ""){
      let customer = this.directSessionLogic.customerSignal();
      if(customer.firstName !== "" && customer.firstName !== undefined){
        this.postLead();
      }
    }else{
      console.log("lead exists, updating information");
      this.updateQuoteFromSession('0');
    }
  }

  postLead(){
    console.log("posting lead");

    let session = this.directSessionLogic.trimmedSessionSignal();

    let customer = this.directSessionLogic.customerSignal();
    let coupon = this.promoService.couponSignal();
    let customerId = session.customerId ?? '';

    const req: AddContactInformationParams = {
      firstName: customer.firstName,
      lastName: customer.lastName,
      address: customer.address,
      zip: customer.zip,
      phone: customer.phoneNumber,
      email: customer.email,
      city: customer.city,
      state: customer.state,
      promo: coupon?.forteCode ?? this.SalePromoCode     // will be related to the coupon code but will default to the company promo code
    };

    // console.log("req: ", req)

    try{
      this.directApiService.addContactInformation(req).subscribe((res: any) => {
        const leadResponse = res.response.leadResponseItem;
        if(leadResponse.responseCode == '0000'){
          //Success
          let appNumber: any = leadResponse.assignedSlstId;
          console.log("lead added: " + appNumber);
          session.customerId = appNumber;
          this.directSessionLogic.updateTrimmedSessionSignal(session);
          this.updateQuoteFromSession('0'); //use 0 for new lead
        }
        else if(leadResponse.responseCode == '0009'){
          //Existing customer. Probably won't happen in this app. 
          console.log("lead already exists: ", leadResponse.responseCode);
        }
        else{
          //Other failure
          console.log("lead failed: ", leadResponse.responseCode);
        }
      });
    }
    catch(err){
      //not sure why error on posting lead if refreshing page in the middle
      //still need to diagnose but it should work once I can figure out how to resolve the error
      //error is "this.directApiService.addContactInformation is not a function" -AG
      console.log("error posting lead: ", err);
    }

  }

  async updateQuoteFromSession(disposition: string){
    let quote : UpdateQuote = {} as UpdateQuote;
    let session = this.directSessionLogic.trimmedSessionSignal();
    let coupon = this.promoService.couponSignal();
    let customer = this.directSessionLogic.customerSignal();

    quote.appNumber = session.customerId;
    quote.lastName = customer.lastName;
    quote.firstName = customer.firstName;
    quote.address = customer.address;
    quote.city = customer.city;
    quote.state = customer.state;
    quote.zip = customer.zip;
    quote.phone = customer.phoneNumber;
    quote.coverage = this.directSessionLogic.selectedPlanSignalValue.forteCode;
    quote.cuscost = session.totalCost?.toString();
    quote.downpay = '0';
    quote.listCode = this.directSessionLogic.selectedPlanSignalValue.forteCode;
    // quote.listCode2 = '';
    quote.promo = coupon?.forteCode ?? this.SalePromoCode;   // will be related to the coupon code but will default to the company promo code

    quote.email = customer.email;
    quote.gensur1 = "";
    if(this.directSessionLogic.cartItemsSignalValue?.length > 0) {
      quote.gensur1 += this.directSessionLogic.cartItemsSignalValue[0].optionValue;
    }
    
    quote.dispcode = disposition;
    quote.salesman = "WebSales";

    try{
      this.directApiService.updateQuote(quote).subscribe((res: any) => {
        console.log("Quote updated");
      });
    }
    catch(err){
      console.log("error updating quote: ", err);
    }

  }
}
